export const IsShowAllRequirementVendorList = Symbol.for('IsShowAllRequirementVendorList');
